import { Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { I18nService } from '../../core/i18n.service';

@Component({
  selector: 'app-download-sheet',
  standalone: true,
  templateUrl: './app-download-sheet.component.html',
  styleUrl: './app-download-sheet.component.scss',
})
export class AppDownloadSheetComponent implements OnDestroy {
  protected readonly i18n = inject(I18nService);
  protected readonly platform = this.detectPlatform();
  @ViewChild('dialog') private dialog?: ElementRef<HTMLDialogElement>;
  private previousBodyOverflow: string | null = null;

  open(): void {
    const dialog = this.dialog?.nativeElement;
    if (!dialog || dialog.open) {
      return;
    }

    dialog.showModal();
    this.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  protected close(): void {
    this.dialog?.nativeElement.close();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === this.dialog?.nativeElement) {
      this.close();
    }
  }

  protected restoreBodyScroll(): void {
    if (this.previousBodyOverflow !== null) {
      document.body.style.overflow = this.previousBodyOverflow;
      this.previousBodyOverflow = null;
    }
  }

  ngOnDestroy(): void {
    this.restoreBodyScroll();
  }

  private detectPlatform(): 'android' | 'ios' | 'other' {
    if (typeof navigator === 'undefined') {
      return 'other';
    }

    if (/android/i.test(navigator.userAgent)) {
      return 'android';
    }

    if (
      /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    ) {
      return 'ios';
    }

    return 'other';
  }
}
